import {
    GET_MENTIONS_FAIL,
    GET_MENTIONS_SUCCESS,
    ADD_MENTION_SUCCESS,
    ADD_MENTION_FAIL,
    UPDATE_MENTION_SUCCESS,
    UPDATE_MENTION_FAIL,
    DELETE_MENTION_SUCCESS,
    DELETE_MENTION_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    mentions: [],
    error: null,
    loading: true
};

const mentionReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des mentions
        case GET_MENTIONS_SUCCESS:
            return {
                ...state,
                mentions: action.payload, // tableau d'objets mention
                loading: false,
                error: null
            };

        case GET_MENTIONS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une department
        case ADD_MENTION_SUCCESS:
            return {
                ...state,
                mentions: [action.payload, ...state.mentions], // ajoute au début du tableau
                error: null
            };

        case ADD_MENTION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une department
        case UPDATE_MENTION_SUCCESS:
            return {
                ...state,
                mentions: state.mentions.map(mention =>
                    mention.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet mention
                        : mention
                ),
                error: null
            };

        case UPDATE_MENTION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une department
        case DELETE_MENTION_SUCCESS:
            return {
                ...state,
                mentions: state.mentions.filter(
                    mention => mention.id !== action.payload
                ),
                error: null
            };


        case DELETE_MENTION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default mentionReducer;
